<template>
<div>
    <div class="im-label">Check-in</div>
    <div class="major mt-1 mb-2">
        {{ getFullDate(item.check_in) }}
    </div>
    <div class="im-label">Check-out</div>
    <div class="major mt-1 mb-2">
        {{ getFullDate(item.check_out) }}
    </div>
</div>
</template>

<script>
import defaults from "../../../utils/PropDefaults.js";

export default {

    props: {
        item: {
            type: Object,
            default: function () {
                return defaults.reservation_item
            }
        },
    },

    methods: {

        getFullDate(date) {
            if(!date) return date;
            // let value = date * 1000;
            return this.$moment(date)
                .locale(this.$vuetify.lang.current)
                .format('ddd, DD MMM YY');
        },

    },
}
</script>
